import axios from "axios";
import React, {useEffect, useState, useRef, Fragment} from "react";
import {Link, NavLink, useParams, useNavigate, useLocation} from "react-router-dom"
import {render} from "react-dom";
import clientconfigwebapp, {
    empty_bk,
    convert_to_english_strhk,
    scrollTo_uphk,
    check_login_appbk,
    Token_get_appbk,
    redirectbh_typeb,
    getLengt_arraybk,
} from '../../../clientconfigwebapp';
import {ToastContainer, toast} from 'react-toastify';

import Master_Front_Buyer from "../../../pages/Master_Front_Buyer";


import ReactFullPageLoadinghk from "../../../components/layaout/LoadingFullpagehk";


import '../../../assets/cssnew/request-reg.css'

import Category_Selector_Large from "../../../components/CategorySelector/Category_Selector_Large";
import Image_Files_Uploads from "../../../components/Panel_Simple/Product_Reg/Image_Files_Uploads";


import serialize from "form-serialize";

import Grid from "@mui/material/Grid";

import MenuItem from '@mui/material/MenuItem';
import Select from '@mui/material/Select';
const Product_Edit = (props) => {

    const location = useLocation()


    const location_get_urlbk = useLocation();
    const redirect_navigate = useNavigate();
    const [loadinghkfullshow, Setloadinghkfullshow] = useState("false");

    /*  start profile */
    const [wallet_balance, setData_wallet_balance] = useState('0');
    const [first_name_profile, setData_first_name_profile] = useState('');
    const [last_name_profile, setData_last_name_profile] = useState('');
    const [profile_src, setData_profile_src] = useState('');
    const [type_user_panel, setData_type_user_panel] = useState('');
    /*  end profile */

    const [active_tab_curent, set_active_tab_curent] = useState("tab1")

    const [cat_list_full, setData_cat_list_full] = useState([]);
    const [Data_Full_Get, setData_Data_Full_Get] = useState([]);



    const [price_input_price, setData_input_price] = useState('');
    const [input_product_type_text, setData_input_product_type_text] = useState('');
    const [input_order_amount, setData_input_order_amount] = useState('');

    const [input_shipping_time, setData_input_shipping_time] = useState('');

    const Handler_input_price = (event) => {
        setData_input_price(convert_to_english_strhk(event.target.value));
    }


    const Handler_input_product_type_text = (event) => {
        setData_input_product_type_text(convert_to_english_strhk(event.target.value));
    }

    const Handler_input_order_amount = (event) => {
        setData_input_order_amount(convert_to_english_strhk(event.target.value));
    }


    const Handler_input_shipping_time = (event) => {
        setData_input_shipping_time(convert_to_english_strhk(event.target.value));
    }

    const {post_id} = useParams();

    useEffect(() => {
        scrollTo_uphk();
        if (check_login_appbk() == false) {
            redirectbh_typeb(String(clientconfigwebapp.webappurl) + "login-register" );
            return false;
        }
        Load_api_page();

    }, [location_get_urlbk]);

    const Load_api_page = () => {

        if (check_login_appbk() == false) {
            redirectbh_typeb(String(clientconfigwebapp.webappurl) + "login-register");
        }

        const config = {
            headers: {Authorization: `Bearer ${Token_get_appbk()}`}
        };


        Setloadinghkfullshow("true");


        let form_data = document.querySelector('#form_data');
        if (form_data != null) {

            let data_serialize = serialize(form_data);


            axios.post(`${clientconfigwebapp.siteurl}api/v1/panel/product-info/`, data_serialize, config)


                .then((res) => {
                    Setloadinghkfullshow("false");
///console.log(res.data);
                    if (String(res.data).length > 0) {

                        if (String(res.data.data) == "login-show") {
                            redirectbh_typeb(String(clientconfigwebapp.webappurl) + "login");
                        }

                        if (!empty_bk(res.data.type_user)) { setData_type_user_panel(res.data.type_user); }


                        if (String(res.data.wallet_inventory).length > 0) {
                            setData_wallet_balance(res.data.wallet_inventory);
                        }
                        if (!empty_bk(res.data.first_name_profile)) {
                            setData_first_name_profile(res.data.first_name_profile);
                            localStorage.setItem('first_name_Get', res.data.first_name_profile);
                        }
                        if (!empty_bk(res.data.last_name_profile)) {
                            setData_last_name_profile(res.data.last_name_profile);
                            localStorage.setItem('last_name_Get', res.data.last_name_profile);
                        }
                        if (!empty_bk(res.data.profile_src)) {
                            setData_profile_src(res.data.profile_src);
                        }




                        if(getLengt_arraybk(res.data.cat_list_full) > 0 ) {  setData_cat_list_full(res.data.cat_list_full); }else{  setData_cat_list_full([]);  }
                        if(getLengt_arraybk(res.data) > 0 ) {  setData_Data_Full_Get(res.data); }else{  setData_Data_Full_Get([]);  }


                        setData_input_price(res.data.data.price);
                        setData_input_product_type_text(res.data.data.product_type_text);
                        setData_input_order_amount(res.data.data.order_amount);
                        setData_input_shipping_time(res.data.data.shipping_time);

                    } else {
                        if (String(res.data.msgwebapp).length > 0) toast.error(res.data.msgwebapp, {
                            position: "top-center",
                            autoClose: 5000,
                            hideProgressBar: false,
                            closeOnClick: true,
                            pauseOnHover: true,
                            draggable: true,
                            progress: undefined,
                        });
                    }

                }).catch((err) => {
                Setloadinghkfullshow("false");
                toast.error('خطا اتصال به سرور کد  435346', {
                    position: "top-center",
                    autoClose: 5000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                });
            });


        }


    }



    const Handler_Product_Reg = () => {


        // return toast.error('خطا اتصال به سرور کد  2342326', {
        //     position: "top-center",
        //     autoClose: 5000,
        //     hideProgressBar: false,
        //     closeOnClick: true,
        //     pauseOnHover: true,
        //     draggable: true,
        //     progress: undefined,
        // });


        if (check_login_appbk() == false) {
            redirectbh_typeb(String(clientconfigwebapp.webappurl) + "login");
        }


        var cat_id= document.getElementById("cat_id").value;




            const config = {
                headers: {Authorization: `Bearer ${Token_get_appbk()}`}
            };
            Setloadinghkfullshow("true");


            let form_data = document.querySelector('#form_data');
            if (form_data != null) {
                let formDatanew = new FormData(form_data);
                ///formDatanew.append("step", "1");
                let data_serialize = new URLSearchParams(formDatanew).toString();



                axios.post(`${clientconfigwebapp.siteurl}api/v1/panel/product-edit/`, data_serialize, config)
                    .then((res) => {

                        Setloadinghkfullshow("false");

                        if (String(res.data).length > 0) {

                            if (String(res.data.data) == "login-show") {
                                redirectbh_typeb(String(clientconfigwebapp.webappurl) + "login");
                            }



                            if (String(res.data.status) == "success") {

                                 set_active_tab_curent('tab3');
                            } else {

                                if (String(res.data.msgwebapp).length > 0) toast.error(res.data.msgwebapp, {
                                    position: "top-center",
                                    autoClose: 5000,
                                    hideProgressBar: false,
                                    closeOnClick: true,
                                    pauseOnHover: true,
                                    draggable: true,
                                    progress: undefined,
                                });

                            }


                        } else {
                            if (String(res.data.msgwebapp).length > 0) toast.error(res.data.msgwebapp, {
                                position: "top-center",
                                autoClose: 5000,
                                hideProgressBar: false,
                                closeOnClick: true,
                                pauseOnHover: true,
                                draggable: true,
                                progress: undefined,
                            });
                        }

                    }).catch((err) => {
                    Setloadinghkfullshow("false");
                    toast.error('خطا اتصال به سرور کد  2342326', {
                        position: "top-center",
                        autoClose: 5000,
                        hideProgressBar: false,
                        closeOnClick: true,
                        pauseOnHover: true,
                        draggable: true,
                        progress: undefined,
                    });
                });


            }








    }






    return (<Fragment>

<style jsx>{`

.btn-blue-reg-product-panel{

background-color: #0e8ed4;
}
`}</style>


            <Master_Front_Buyer type_user_panel={type_user_panel} wallet_balance={wallet_balance} first_name_profile={first_name_profile}
                                last_name_profile={last_name_profile} profile_src={profile_src}>
                <ReactFullPageLoadinghk loadinghk={loadinghkfullshow}/>
                <ToastContainer/>


                <div className={"box-content-panelbk"}>

                    <span className={"title-box-content-panel"}>ثبت محصول</span>

                    <form id={"form_data"} name={"form_data"} encType="multipart/form-data" style={{width: "100%"}}>

                        <input type={"text"} id={"cat_id"} name={"cat_id"}/>

                        <input type={"text"} id={"post_id"} name={"post_id"} value={post_id}  />



                        <div style={{
                            "flexDirection": "column",
                            display: String(active_tab_curent) === 'tab1' ? 'flex' : 'none'
                        }}>


                            <div className="tab2-box-req-reg">

                                <Grid container direction="row" spacing={2}>


                                    <Grid item lg={6} md={6} sm={12} xs={12}>


                                        <div className={"inputbk-container"}>
                                            <label>نوع محصول</label>

                                            <input name={"product_type_text"} className="inputbk" value={input_product_type_text} onChange={Handler_input_product_type_text}
                                                   placeholder="نوع محصول مورد نظر خود را وارد کنید."/>
                                        </div>
                                        <span style={{
                                            display: 'flex',
                                            flexDirection: 'row-reverse',
                                            alignItems: 'flex-end',
                                            padding: '0px',
                                            flex: 'none',
                                            alignSelf: 'stretch',
                                            flexGrow: 0,
                                            color: '#9ca3af'
                                        }}>مثال : قندقی</span>


                                    </Grid>

                                    <Grid item lg={6} md={6} sm={12} xs={12}>


                                        <div className={"inputbk-container"}>
                                            <label>میزان سفارش</label>


                                            <div style={{
                                                display: 'flex',
                                                flexDirection: 'row-reverse',
                                                width: '100%',
                                                position: 'relative'
                                            }}>
                                                <input name={"order_amount"} className="inputbk" value={input_order_amount} onChange={Handler_input_order_amount}
                                                       placeholder="مقدار مورد نیاز را وارد نمایید"/>
                                                <span
                                                    style={{
                                                        borderRight: '1px solid rgb(229, 231, 235)',
                                                        position: 'absolute',
                                                        left: '8px',
                                                        fontSize: '13px',
                                                        display: 'flex',
                                                        placeContent: 'center',
                                                        height: '26px',
                                                        paddingRight: '3px',
                                                        alignItems: 'center',
                                                        top: '13px'
                                                    }}>کیلوگرم</span>
                                            </div>


                                        </div>
                                        <span style={{
                                            display: 'flex',
                                            flexDirection: 'row-reverse',
                                            alignItems: 'flex-end',
                                            padding: '0px',
                                            flex: 'none',
                                            alignSelf: 'stretch',
                                            flexGrow: 0,
                                            color: '#9ca3af'
                                        }}>مثال: 50,000 کیلوگرم</span>


                                    </Grid>





                                    <Grid item lg={6} md={6} sm={12} xs={12}>


                                        <div className={"inputbk-container"}>
                                            <label>قیمت محصول</label>


                                            <div style={{
                                                display: 'flex',
                                                flexDirection: 'row-reverse',
                                                width: '100%',
                                                position: 'relative'
                                            }}>
                                                <input name={"price"} className="inputbk"
                                                       placeholder="قیمت محصول را وارد نمایید" value={price_input_price} onChange={Handler_input_price}  />
                                                <span
                                                    style={{
                                                        borderRight: '1px solid rgb(229, 231, 235)',
                                                        position: 'absolute',
                                                        left: '8px',
                                                        fontSize: '13px',
                                                        display: 'flex',
                                                        placeContent: 'center',
                                                        height: '26px',
                                                        paddingRight: '3px',
                                                        alignItems: 'center',
                                                        top: '13px'
                                                    }}>تومان</span>
                                            </div>


                                        </div>
                                        <span style={{
                                            display: 'flex',
                                            flexDirection: 'row-reverse',
                                            alignItems: 'flex-end',
                                            padding: '0px',
                                            flex: 'none',
                                            alignSelf: 'stretch',
                                            flexGrow: 0,
                                            color: '#9ca3af'
                                        }}>مثال: 150,000 تومان</span>


                                    </Grid>


                                    <Grid item lg={6} md={6} sm={12} xs={12}>


                                        <div className={"inputbk-container"}>
                                            <label>زمان تقریبی تحویل سفارش(روز)</label>


                                            <div style={{
                                                display: 'flex',
                                                flexDirection: 'row-reverse',
                                                width: '100%',
                                                position: 'relative'
                                            }}>
                                                <input name={"shipping_time"} className="inputbk"
                                                       placeholder="مثلا 30" value={input_shipping_time} onChange={Handler_input_shipping_time}  />
                                                <span
                                                    style={{
                                                        borderRight: '1px solid rgb(229, 231, 235)',
                                                        position: 'absolute',
                                                        left: '8px',
                                                        fontSize: '13px',
                                                        display: 'flex',
                                                        placeContent: 'center',
                                                        height: '26px',
                                                        paddingRight: '3px',
                                                        alignItems: 'center',
                                                        top: '13px'
                                                    }}>روز</span>
                                            </div>


                                        </div>



                                    </Grid>



                                    <Grid item lg={12} md={12} sm={12} xs={12}>

                                        <Image_Files_Uploads setActiveTabCurrent={set_active_tab_curent} Data_Full_Get={Data_Full_Get}/>

                                    </Grid>


                                    <Grid item lg={12} md={12} sm={12} xs={12}>


                                        <div className={"inputbk-container"}>
                                            <label>توضیحات بیشتر</label>

                                            <textarea name={"description"} style={{
                                                "width": "100%",
                                                "height": "132px",
                                                "border": "solid 1px #e4e4e4",
                                                "borderRadius": "10px",
                                                "padding": "11px",
                                                "fontSize": "13px",
                                                "marginTop": "4px",
                                                "marginBlock": "4px"
                                            }} aria-multiline={8}
                                                      placeholder={"توضیحات تکمیلی:\n بسته بندی، رنگ ، اندازه ، ابعاد،گواهی و استاندارد و کیفیت محصول، نوع فروش و روش نگهداری و ماندگاری محصول"}></textarea>

                                        </div>


                                    </Grid>


                                </Grid>

                            </div>


                            <div style={{
                                "display": "flex",
                                "placeContent": "center space-between",
                                "flexDirection": "row",
                                "alignItems": "center",
                                "padding": "13px",
                                "borderTop": "2px solid rgb(229, 231, 235)",
                                "justifyContent": "space-between"
                            }}>
                                <Link reloadDocument={true} to={"/panel/my-products"}
                                        className={"btn-cansel-step-request bg-hover-bluebk"}>
                                    <svg width="24px" height="24px" viewBox="0 -6.5 36 36" version="1.1"
                                         xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink"
                                         fill="#000000">
                                        <g id="SVGRepo_bgCarrier" strokeWidth={0}/>
                                        <g id="SVGRepo_tracerCarrier" strokeLinecap="round" strokeLinejoin="round"/>
                                        <g id="SVGRepo_iconCarrier"><title>right-arrow</title>
                                            <desc>Created with Sketch.</desc>
                                            <g id="icons" stroke="none" strokeWidth={1} fill="none" fillRule="evenodd">
                                                <g id="ui-gambling-website-lined-icnos-casinoshunter"
                                                   transform="translate(-212.000000, -159.000000)" fill="#252528"
                                                   fillRule="nonzero">
                                                    <g id="square-filled" transform="translate(50.000000, 120.000000)">
                                                        <path
                                                            d="M187.108012,39.2902857 L197.649804,49.7417043 L197.708994,49.7959169 C197.889141,49.9745543 197.986143,50.2044182 198,50.4382227 L198,50.5617773 C197.986143,50.7955818 197.889141,51.0254457 197.708994,51.2040831 L197.6571,51.2479803 L187.108012,61.7097143 C186.717694,62.0967619 186.084865,62.0967619 185.694547,61.7097143 C185.30423,61.3226668 185.30423,60.6951387 185.694547,60.3080911 L194.702666,51.3738496 L162.99947,51.3746291 C162.447478,51.3746291 162,50.9308997 162,50.3835318 C162,49.8361639 162.447478,49.3924345 162.99947,49.3924345 L194.46779,49.3916551 L185.694547,40.6919089 C185.30423,40.3048613 185.30423,39.6773332 185.694547,39.2902857 C186.084865,38.9032381 186.717694,38.9032381 187.108012,39.2902857 Z M197.115357,50.382693 L186.401279,61.0089027 L197.002151,50.5002046 L197.002252,50.4963719 L196.943142,50.442585 L196.882737,50.382693 L197.115357,50.382693 Z"
                                                            id="right-arrow"></path>
                                                    </g>
                                                </g>
                                            </g>
                                        </g>
                                    </svg>
                                  انصراف
                                </Link>
                                <button onClick={Handler_Product_Reg}
                                        className={"btn-next-step-request bg-hover-bluebk"}
                                        type={"button"}>ثبت درخواست
                                </button>
                            </div>


                        </div>




                        <div style={{
                            "flexDirection": "column",
                            display: String(active_tab_curent) === 'tab3' ? 'flex' : 'none'
                        }}>


                            <div style={{
                                "display": "flex",
                                "flexDirection": "column",
                                "justifyContent": "center",
                                "alignItems": "center",
                                "paddingTop": "15px",
                                "paddingBottom": "18px"
                            }}>

                                <svg width={63} height={63} viewBox="0 0 63 63" fill="none"
                                     xmlns="http://www.w3.org/2000/svg">
                                    <g clipPath="url(#clip0_0_4438)">
                                        <path
                                            d="M31.5 5.66669C17.24 5.66669 5.66663 17.24 5.66663 31.5C5.66663 45.76 17.24 57.3334 31.5 57.3334C45.76 57.3334 57.3333 45.76 57.3333 31.5C57.3333 17.24 45.76 5.66669 31.5 5.66669ZM26.3333 44.4167L13.4166 31.5L17.0591 27.8575L26.3333 37.1059L45.9408 17.4984L49.5833 21.1667L26.3333 44.4167Z"
                                            fill="#0E9F6E"/>
                                    </g>
                                    <defs>
                                        <clipPath id="clip0_0_4438">
                                            <rect width={62} height={62} fill="white" transform="translate(0.5 0.5)"/>
                                        </clipPath>
                                    </defs>
                                </svg>


                                <span style={{
                                    fontSize: '22px',
                                    fontWeight: 'bold',
                                    marginBottom: '30px',
                                    marginTop: '30px'
                                }}>ارسال موفق</span>

                                <span style={{
                                    fontSize: '15px',
                                    color: '#4B5563',
                                    fontFamily: '"iran"',
                                    display: 'block',
                                    textAlign: 'center',
                                    "lineHeight": "1.6"
                                }}>اطلاعات شما با موفقیت برای کارشناسان بازارانو ارسال شد،<br/> پس از بررسی و تایید کارشناسان، منتشر خواهد شد.</span>


                            </div>


                        </div>


                    </form>

                </div>


            </Master_Front_Buyer>
        </Fragment>
    );
}


export default Product_Edit;